import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { env } from "env";
import { NavLink } from "react-router-dom";
export function Header(param) {
    var selectbranchID = param.selectbranchID;
    function handleSlide(index) {
        var slide = document.querySelectorAll(".slide");
        for(var i = 0; i < slide.length; i++){
            slide[i].classList.remove("is-expanded");
        }
        slide[index].classList.add("is-expanded");
    }
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "app-sidebar__overlay",
                "data-toggle": "sidebar"
            }),
            /*#__PURE__*/ _jsxs("aside", {
                className: "app-sidebar sidebar-scroll",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "main-sidebar-header px-0 active",
                        children: [
                            /*#__PURE__*/ _jsx("a", {
                                className: "desktop-logo active text-decoration-none mb-4 ",
                                href: "",
                                children: /*#__PURE__*/ _jsx("img", {
                                    src: env.REACT_APP_LOGO_URL,
                                    className: "main-logo my-3",
                                    alt: "logo"
                                })
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                className: "logo-icon mobile-logo py-2 px-0 icon-light active",
                                href: "",
                                children: /*#__PURE__*/ _jsx("img", {
                                    src: env.REACT_APP_LOGO_URL,
                                    className: "logo-icon mx-auto",
                                    alt: "logo"
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "py-3"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "main-sidemenu px-2 ",
                        children: /*#__PURE__*/ _jsx("ul", {
                            className: "side-menu",
                            children: /*#__PURE__*/ _jsx("li", {
                                className: "slide",
                                children: /*#__PURE__*/ _jsxs("a", {
                                    className: "side-menu__item py-2 ",
                                    href: "#",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "side-menu_icon",
                                            children: /*#__PURE__*/ _jsx("div", {
                                                className: "side-menu__icon icon-home"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "side-menu__label",
                                            children: " Dashboard"
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
}
